/**
 * @param { string } str String to clean.
 * @returns { string } String trimmed from whitespace and with only one space between words.
 */
export function cleanString(str) {
  return str.replace(/\s+/g, ' ').trim();
}
